<header class="stitch-header">
  <!-- Main Navbar Bar -->
  <nav class="stitch-navbar py-3 bg-white border-bottom shadow-sm">
    <div class="container-fluid px-lg-5 d-flex align-items-center justify-content-between">

      <!-- Brand Logo Stitch -->
      <a class="stitch-brand-logo d-flex align-items-center text-decoration-none me-4" routerLink="/">
        <div class="logo-icon-wrapper">
          <i class="fas fa-mountain logo-icon"></i>
        </div>
        <div class="logo-text-wrapper ms-2">
          <span class="brand-title">Tienda Virtual</span>
        </div>
      </a>

      <!-- Acciones de Usuario & Carrito -->
      <div class="stitch-nav-actions d-flex align-items-center gap-3 ms-auto">

        <!-- Botón del Carrito con Badges -->
        <a class="stitch-cart-widget text-decoration-none" routerLink="/cart">
          <div class="cart-icon-box">
            <i class="fas fa-shopping-bag"></i>
            <span class="cart-badge-count">{{ cartItemCount }}</span>
          </div>
          <div class="cart-amount-box d-none d-lg-flex flex-column">
            <span class="cart-label">Mi Carrito</span>
            <span class="cart-total-value">${{ cartTotalAmount | number }} COP</span>
          </div>
        </a>

        <!-- Menú de Autenticación / Mi Cuenta -->
        <ng-container *ngIf="!(isAuthenticated$ | async)">
          <a class="btn-stitch-login text-decoration-none" routerLink="/login">
            <i class="fas fa-user-circle me-2 fs-5"></i>
            <span>Ingresar</span>
          </a>
        </ng-container>

        <ng-container *ngIf="isAuthenticated$ | async">
          <div class="user-account-dropdown position-relative">
            <button class="btn-stitch-account-pill d-flex align-items-center gap-2" (click)="toggleUserMenu($event)"
              type="button" aria-expanded="userMenuOpen" title="Opciones de Mi Cuenta">
              <div class="user-avatar-badge">
                <i class="fas fa-user-circle"></i>
              </div>
              <div class="user-account-info d-none d-md-flex flex-column text-start">
                <span class="user-account-label">Mi Cuenta</span>
              </div>
              <i class="fas fa-chevron-down chevron-icon ms-1" [class.rotated]="userMenuOpen"></i>
            </button>

            <!-- Menu Desplegable de Opciones -->
            <div class="stitch-dropdown-card shadow-lg border-0 py-2 mt-2" [class.show]="userMenuOpen">

              <!-- Header de Perfil con Avatar y Datos del Usuario -->
              <div class="dropdown-header-banner p-3 border-bottom d-flex align-items-center gap-3">
                <div class="header-avatar-circle">
                  <span>{{ userName.charAt(0).toUpperCase() }}</span>
                </div>
                <div class="header-user-info text-truncate">
                  <h6 class="fw-bold m-0 text-dark text-truncate">{{ userName }}</h6>
                  <span class="small text-muted text-truncate d-block">{{ userEmail }}</span>
                </div>
              </div>

              <!-- Lista de Opciones de Navegación -->
              <div class="dropdown-body p-2">
                <a class="stitch-dropdown-item py-2 px-3 d-flex align-items-center gap-3 text-decoration-none rounded-3"
                  (click)="goToProfile()" style="cursor: pointer;">
                  <div class="item-icon-box bg-indigo-subtle text-indigo rounded-circle">
                    <i class="fas fa-id-card"></i>
                  </div>
                  <div class="flex-grow-1">
                    <span class="item-title d-block fw-semibold text-dark">Mi Perfil & Dirección</span>
                    <span class="item-desc extra-small text-muted">Datos personales de envío</span>
                  </div>
                  <i class="fas fa-chevron-right small text-muted ms-auto"></i>
                </a>

                <div class="dropdown-divider my-2"></div>

                <button
                  class="stitch-dropdown-item logout-btn py-2 px-3 d-flex align-items-center gap-3 w-100 text-start bg-transparent border-0 rounded-3"
                  (click)="logout()">
                  <div class="item-icon-box bg-rose-subtle text-rose rounded-circle">
                    <i class="fas fa-power-off"></i>
                  </div>
                  <div class="flex-grow-1">
                    <span class="item-title d-block fw-bold text-danger">Cerrar Sesión</span>
                    <span class="item-desc extra-small text-muted">Finalizar sesión segura</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Toggle Menú Móvil -->
        <button class="btn-mobile-toggle d-lg-none" (click)="toggleMenu()" aria-label="Abrir menú">
          <i class="fas" [ngClass]="menuOpen ? 'fa-times' : 'fa-bars'"></i>
        </button>

      </div>
    </div>
  </nav>

  <!-- Sub-Navbar de Navegación Simplificado & Elegante -->
  <div class="stitch-subnav bg-white border-bottom d-none d-lg-block py-2">
    <div class="container-fluid px-lg-5">
      <ul class="subnav-list d-flex align-items-center gap-4 m-0 p-0 list-unstyled">
        <li>
          <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="subnav-link">
            Inicio
          </a>
        </li>
        <li>
          <a routerLink="/shop" class="subnav-link">
            <i class="fa-solid fa-box-isometric"></i> Productos
          </a>
        </li>
        <li>
          <a routerLink="/shop" [queryParams]="{ category: 'Ofertas Flash' }" class="subnav-link flash-link">
            <i class="fas fa-bolt me-1"></i> Ofertas
          </a>
        </li>
        <li>
          <a routerLink="/about" class="subnav-link">
            Quiénes Somos
          </a>
        </li>
        <li>
          <a routerLink="/contact" class="subnav-link">
            Contáctenos
          </a>
        </li>
      </ul>
    </div>
  </div>
</header>